@app.directive 'csEmbedVideo', ->
  restrict: 'E'
  replace: false
  scope: {}
  bindToController:
    youtubeId: '@'
    vimeoId: '@'
    videoSources: '='
    autoplay: '='
  controllerAs: 'csEmbedVideo'
  controller: ($scope) ->
    @autoplay = @autoplay || 0
    @getType = =>
      if @videoSources
        'native'
      else if @vimeoId
        'vimeo'
      else if @youtubeId
        'youtube'
    this

  templateUrl: "/assets/templates/directives/csEmbedVideo/csEmbedVideo.html"
